import styled from "styled-components";

export const StyledEmbed = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: black;
`;

export const Preview = styled.div`
    width: 1280px;
    height: 720px;
    background-color: white;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PreziPreview = styled.img.attrs({ src: "/images/prezi-logo-dark.svg" })`
    width: 800px;
`;
